// 引入依赖
import {JSEncrypt} from "jsencrypt";
import jsbn from "jsbn";

const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApk2WGYuq26+g3djMgg2VkjyKiU3Z691Kah5h/0o6Ow12PoS7I+3hNC5kT9hd40M6grIVl8af6zuO9PP7h3w49pbZfM4XTxKbLNzL1MtGiKZ5LN6bKxhXCUGqmDRcgjV/mkGKplM1m/57iYhqTjb4bpMFUwY38vEA5QDqn1wG6UYTRLbK4zxQtZreUK3R8hIdUF5TL7BAkC3RS78AX07HV5yOMqRaHS4B3zI1MerOMoQrUu9eEzu3nDI1r54ulp8Z467VofXSEQDuWGIrntWj4TLHza7a+zeax8apFqugdgstKuY2b6hFKzIZ3xO7l3XkokaxnVli9chl9CclKidMjQIDAQAB'

export function decV2(signatureBase64){
  console.log(signatureBase64)
  const encBytes = Uint8Array.from(atob(signatureBase64), c => c.charCodeAt(0));
  const decBytes = decLongContent(publicKey,encBytes);

  const nonceBytes=decBytes.subarray(0,16);
  const nonceHex=Array.from(nonceBytes, b => b.toString(16).padStart(2,'0')).join('');
  const timestampInt=new DataView(decBytes.buffer,16,4).getInt32(0, false);
  const dataBytes=decBytes.subarray(20,decBytes.length);
  //
  // console.log(timestampInt);
  // //todo 验证请求未超时
  // console.log(nonceHex);
  // //todo 验证请求未重放
  const decoder = new TextDecoder('utf-8');
  return decoder.decode(dataBytes);
}


function decPart(encPartBytes,rsaKey){
  try{
    var BigInteger = jsbn.BigInteger;
    let encPartBI= new BigInteger(Array.from(encPartBytes).map(b => b.toString(16).padStart(2, '0')).join(''), 16);
    let decBI = rsaKey.doPublic(encPartBI);
    let decHex = decBI.toString(16);
    //console.log(decHex);
    if (decHex.length % 2 !== 0){
      decHex = '0' + decHex;
    }
    const decBytes = new Uint8Array(decHex.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
    let point=-1;
    for (let i=0;i<decBytes.length;i++){
      if (decBytes[i]==0){
        point=i;
        break;
      }
    }
    return decBytes.subarray(point+1,decBytes.length);
  } catch (e) {
    console.error('部分解密失败:', e);
  }
}

function decLongContent(publicKey,encBytes){
  try {
    console.log(publicKey,encBytes)
    const rsa = new JSEncrypt();
    rsa.setPublicKey(publicKey);
    const key = rsa.getKey();

    const decBytesParts=[];
    for (let i=0;i<encBytes.length;i+=256){
      let decBytePart=decPart(encBytes.subarray(i,i+256),key);
      decBytesParts.push(decBytePart);
    }

    // 计算总长度
    const decBytesLength = decBytesParts.reduce((sum, decBytesPart) => sum + decBytesPart.length, 0);

    // 创建新 Uint8Array
    const decBytes = new Uint8Array(decBytesLength);

    // 依次拷贝
    let offset = 0;
    for (const decBytesPart of decBytesParts) {
      decBytes.set(decBytesPart, offset);
      offset += decBytesPart.length;
    }

    return decBytes;
  } catch (e) {
    console.error('解密失败:', e);
  }

}
